/** Client-side upload limits — keep aligned with backend `upload-limits.constants.ts`. */
export const UPLOAD_LIMITS = {
  entityPhotoBytes: 10 * 1024 * 1024,
  articlePhotoBytes: 25 * 1024 * 1024,
  pdfDocumentBytes: 100 * 1024 * 1024,
  videoBytes: 200 * 1024 * 1024,
};

export const UPLOAD_LIMIT_LABELS = {
  entityPhoto: '10 Mo',
  articlePhoto: '25 Mo',
  pdfDocument: '100 Mo',
  video: '200 Mo',
};

export const ENTITY_PHOTO_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

export function isEntityPhotoFile(file) {
  return ENTITY_PHOTO_MIME_TYPES.includes(file?.type);
}

export function validateEntityPhotoFile(file, t = (value) => value) {
  if (!file) {
    return { ok: false, message: t('Aucun fichier sélectionné.') };
  }
  if (!isEntityPhotoFile(file)) {
    return { ok: false, message: t('Format JPG, PNG ou WebP uniquement.') };
  }
  if (file.size > UPLOAD_LIMITS.entityPhotoBytes) {
    return {
      ok: false,
      message: t(`Format JPG, PNG ou WebP de ${UPLOAD_LIMIT_LABELS.entityPhoto} maximum.`),
    };
  }
  return { ok: true, message: null };
}

export function entityPhotoHint(t = (value) => value) {
  return t(`Format JPG, PNG ou WebP de ${UPLOAD_LIMIT_LABELS.entityPhoto} maximum`);
}
